import * as React from 'react';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import InvestmentProfileCardComponent
  from 'src/modules/modals/investment-funnel/partials/InvestmentProfileCard.component';
import Project from 'src/entities/Project';
import InterestedProjectCardComponent from 'src/modules/my-portfolio/partials/InterestedProjectCard.component';
import MyPortfolioSummaryComponent from 'src/modules/my-portfolio/partials/MyPortfolioSummary.component';
import InvestedProjectCardComponent from 'src/modules/my-portfolio/partials/InvestedProjectCard.component';
import Person from 'src/entities/Person';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import ProfileMetrics from 'src/value-objects/ProfileMetrics';
import CommitmentProjectCardComponent from './partials/CommitmentProjectCard.component';

export interface MyPortfolioComponentProps {
  physicalPerson: PhysicalPerson;
  juridicalPersons: JuridicalPerson[];
  interestedProjects: Project[];
  investedProjects: Project[];
  defaultProfile: Person;
  activeProfile?: Person;
  metrics?: ProfileMetrics;
  handleClick: (index?: number) => void;
}

class MyPortfolioComponent extends React.Component<MyPortfolioComponentProps> {

  public ifDefault(person: Person): boolean {
    return (person.id === this.props.defaultProfile.id &&
      person.personType === this.props.defaultProfile.personType);
  }

  public ifActive(person: Person): boolean {
    return (person.id === this.props.activeProfile!.id &&
      person.personType === this.props.activeProfile!.personType);
  }

  public renderInterested() {
    const rows: Project[][] = [];
    let nextRow: Project[];
    this.props.interestedProjects.forEach((project: Project, index: number) => {
      if (index % 4 === 0) {
        nextRow = [];
        rows.push(nextRow);
      }
      nextRow.push(project);
    });

    return rows.map((row, index) => (
      <div className="row" key="index">
        {
          row.map(
            (project: Project) => (
              <InterestedProjectCardComponent
                project={project}
                key={project.id}
              />
            )
          )
        }
      </div>
    ));
  }

  public render(): React.ReactNode {
    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <h1 className="bold-title">
                Mi cartera
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-md-4">
              <p className="breadcrumb text-right">
                Inicio > Mi cartera
              </p>
            </div>
          </div>
          <p>
            <b>
              Selecciona la cartera de inversión que quieras visualizar.
            </b>
          </p>
          <div className="gap-20"/>
          <div className="row">
            <InvestmentProfileCardComponent
              name={this.props.physicalPerson.name + ' ' + this.props.physicalPerson.surname}
              juridical={false}
              defaultProfile={this.ifDefault(this.props.physicalPerson)}
              activeProfile={this.ifActive(this.props.physicalPerson)}
              className="col-xs-6 col-md-4 col-lg-4"
              onClick={this.props.handleClick}
              ind={this.props.physicalPerson.id}
            />
            {
              this.props.juridicalPersons.map((juridicalPerson: JuridicalPerson, key: number) => (
                <InvestmentProfileCardComponent
                  key={key}
                  name={juridicalPerson.getName()}
                  juridical={true}
                  activeProfile={this.ifActive(juridicalPerson)}
                  className="col-xs-6 col-md-4 col-lg-4"
                  defaultProfile={this.ifDefault(juridicalPerson)}
                  onClick={this.props.handleClick}
                  ind={juridicalPerson.id}
                />
              ))
            }
          </div>
          <div className="row">
            <div className="col-sm-12">
              <MyPortfolioSummaryComponent metrics={this.props.metrics}/>
            </div>
          </div>

          <div className="gap-50"/>
          <div className="row">
            <div className="col-md-10">
              <h3 className="bold-subtitle">Me interesan</h3>
              <div className="gap-20"/>
            </div>
            <div className="col-md-2">
              {/*TODO*/}
              {/*<div className="dropdown">
                <div
                  className="md-input dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <input
                    className="md-form-control pointer"
                    defaultValue="Ordenar"
                    required={true}
                    type="text"
                  />
                  <span className="d-arrow-down icon-error-input" />
                  <span className="highlight" />
                  <span className="bar" />

                </div>
                <ul className="dropdown-menu">
                  <li><Link to="" className="btn-menu">Nombre</Link>
                  </li>
                  <li role="separator" className="divider" />
                  <li><Link to="" className="btn-menu">Precio</Link>
                  </li>
                  <li role="separator" className="divider" />
                  <li><Link to="" className="btn-menu">Fecha</Link>
                  </li>

                </ul>
              </div>*/}

            </div>
          </div>
          {this.renderInterested()}
          <div className="gap-50"/>
          <div className="row">
            <div className="col-md-10">
              <h3 className="bold-subtitle">Mis compromisos</h3>
              <div className="gap-20"/>
            </div>
            <div className="col-md-2">
              {/*TODO*/}
              {/*<div className="dropdown">...*/}
            </div>
          </div>
          {this.renderCommitments()}
          <div className="gap-50"/>
          <div className="row">
            <div className="col-md-10">
              <h3 className="bold-subtitle">Mi cartera</h3>
              <div className="gap-50"/>
            </div>
            <div className="col-md-2">
              {/*TODO*/}
              {/*<div className="dropdown">
                <div
                  className="md-input dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <input
                    className="md-form-control pointer"
                    defaultValue="Ordenar"
                    required={true}
                    type="text"
                  />
                  <span className="d-arrow-down icon-error-input" />
                  <span className="highlight" />
                  <span className="bar" />

                </div>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      to=""
                      className="btn-menu"
                    >
                      Nombre
                    </Link>
                  </li>
                  <li
                    role="separator"
                    className="divider"
                  />
                  <li>
                    <Link
                      to=""
                      className="btn-menu"
                    >
                      Precio
                    </Link>
                  </li>
                  <li
                    role="separator"
                    className="divider"
                  />
                  <li>
                    <Link
                      to=""
                      className="btn-menu"
                    >
                      Fecha
                    </Link>
                  </li>
                </ul>
              </div>*/}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              {this.renderInvestments()}
            </div>
          </div>
        </div>
      </section>
    );
  }

  private renderCommitments(): React.ReactNode {
    const rows: Project[][] = [];
    let nextRow: Project[];
    this.props.investedProjects
      .filter(project => (project.status === 'En financiación' || project.status === 'Formalizando operación'))
      .forEach((project: Project, index: number) => {
        if (index % 4 === 0) {
          nextRow = [];
          rows.push(nextRow);
        }
        nextRow.push(project);
      });

    return rows.map((row, index) => (
      <div className="row" key={index}>
        {
          row.map(
            (project: Project) => (
              <CommitmentProjectCardComponent
                project={project}
                key={project.id}
              />
            )
          )
        }
      </div>
    ));
  }

  private renderInvestments(): React.ReactNode {
    const rows: Project[][] = [];
    let nextRow: Project[];
    this.props.investedProjects
      .filter(project => project.status === 'Financiado con éxito')
      .forEach((project: Project, index: number) => {
        if (index % 4 === 0) {
          nextRow = [];
          rows.push(nextRow);
        }
        nextRow.push(project);
      });

    return rows.map((row, index) => (
      <div className="row" key={index}>
        {row.map(
          (project: Project) => (
            <InvestedProjectCardComponent
              project={project}
              key={project.id}
            />
          )
        )
        }
      </div>
    ));
  }
}

export default MyPortfolioComponent;



// WEBPACK FOOTER //
// ./src/modules/my-portfolio/MyPortfolio.component.tsx